module.exports = function () {
    return navigator.geolocation;
};



// WEBPACK FOOTER //
// ./src/olycommon/geolocation/geolocation-factory.js